import type { HTMLAttributes, FC, Ref } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

import { agentBlobStyle } from "./AgentBlob.css";

export type AgentBlobProps = HTMLAttributes<HTMLDivElement> &
  RecipeVariants<typeof agentBlobStyle> & {
    /**
     * Whether the animation is paused
     */
    paused?: boolean;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * A simple div component with an infinite scale animation
 */
export const AgentBlob: FC<AgentBlobProps> = ({
  speed,
  paused,
  className,
  ref,
  ...props
}) => (
  <div
    ref={ref}
    className={mergeClasses(agentBlobStyle({ speed, paused }), className)}
    {...props}
  />
);
